import { StyledSearch } from '@/scenes/Gallery/Search/styles';
import Input from '@/components/UI/Input';
import { FC, useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { IGalleryStore } from '@/stores/Gallery';

interface GallerySearchProps {
  galleryStore: IGalleryStore;
}

const GallerySearch: FC<any> = ({ galleryStore }: GallerySearchProps) => {
  const { setSearch, search } = galleryStore;

  const [query, setQuery] = useState<string>(search);

  useEffect(() => {
    setQuery(search);
  }, [search]);

  return (
    <StyledSearch>
      <Input
        type="number"
        placeholder="search by id"
        rounded
        value={query}
        onChange={(e) => setQuery(e.currentTarget.value)}
        onBlur={() => {
          if (query === '' && search !== '') {
            setSearch(query);
          }
        }}
        customAction={{
          label: 'Search',
          onAction: () => {
            setSearch(query);
          },
        }}
        icon={
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z"
              stroke="#A9A9A9"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.7508 15.75L12.4883 12.4875"
              stroke="#A9A9A9"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
      />
    </StyledSearch>
  );
};

export default inject('galleryStore')(observer(GallerySearch));
